import React, { useEffect, useState } from "react";
import "./documents.component.scoped.scss";
import { Box, Button, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../statics/icons";
import { DocumentsService } from "../../../../../services/documents.services";
import { formatDate } from "../../../../../helpers";

const DocumentsComponent = () => {
  const { t } = useTranslation();
  const documentsService = new DocumentsService();
  const [documents, setDocuments] = useState<any>([]);

  const fetchDocuments = async () => {
    const response = await documentsService.list();
    setDocuments(response.data);
    console.log(response);
  };

  const downloadFile = (url: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    fetchDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {documents.length > 0 && (
        <Box className="global__box__content mb-4 p-0">
          <Box className="title">
            <Typography variant="h3" style={{ fontWeight: 400 }}>
              {t("COMPANY_RELEVANT_DOCUAMNTS")}
            </Typography>
          </Box>
          <Box className="content">
            {documents.map((document: any, index: number) => {
              return (
                <Box
                  className="item d-flex align-items-center justify-content-between mb-3"
                  key={index}
                >
                  <Box
                    className="d-flex align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <img src={icons.DOCUMENT} alt="DOCUMENT" />
                    <Box className="info">
                      <Box
                        className="d-flex align-items-center mb-1"
                        style={{ gap: ".5rem" }}
                      >
                        <Typography
                          variant="subtitle2"
                          style={{ fontWeight: 500 }}
                        >
                          {document.document}
                        </Typography>
                        <span className="date">
                          {t("UPLOADED_ON")}{" "}
                          {formatDate(document.createdAt, "DD.MM.YYYY")}
                        </span>
                      </Box>
                      <Typography variant="body1">
                        {t("UPLOADED_BY")} {document.userEmail}
                      </Typography>
                      <Typography variant="body1">
                        {t("FILE_NAME")}: {document.file}
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="actions">
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{
                        color: "#fff",
                        background: "var(--secondary)",
                        fontSize: "1rem",
                        fontWeight: 300,
                        textTransform: "capitalize",
                      }}
                      className="mr-2"
                      size="small"
                      onClick={() => downloadFile(document.url)}
                    >
                      {t("DOWNLOAD")}
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </>
  );
};
export default DocumentsComponent;
